import React from "react";
import {
  AiFillGithub,
  AiOutlineMail,
  AiOutlineLinkedin,
  AiFillCar,
} from "react-icons/ai";
import { FaRobot, FaCube, FaShoppingCart } from "react-icons/fa";
import { GiFactory } from "react-icons/gi";
import { BsPersonCircle } from "react-icons/bs";
import { AiFillProject } from "react-icons/ai";
import { TbDeviceComputerCamera } from "react-icons/tb";
import { MdOutlineLocalGroceryStore } from "react-icons/md";
import { TiWeatherPartlySunny } from "react-icons/ti";
import { BiPaint } from "react-icons/bi";
import { FaMosque } from "react-icons/fa";
import { RiFocus3Fill } from "react-icons/ri";
import { SiIkea } from "react-icons/si";
import { MdFoodBank } from "react-icons/md";
export const topSkills = [
  {
    id: 1,
    text: "JS",
  },
  {
    id: 2,
    text: "REACT",
  },
  {
    id: 3,
    text: "CSS",
  },
  {
    id: 4,
    text: "HTML",
  },

  {
    id: 5,
    text: "Node",
  },
  {
    id: 6,
    text: "MongoDB",
  },
  {
    id: 7,
    text: "Express JS",
  },
  {
    id: 8,
    text: "DaisyUI",
  },
  {
    id: 9,
    text: "Tailwind",
  },
  {
    id: 10,
    text: "MERN",
  },

  // {
  //   id: 11,
  //   text: "Arduino",
  // },
  // {
  //   id: 12,
  //   text: "C & C++",
  // },
  // {
  //   id: 13,
  //   text: "OOP",
  // },
  // {
  //   id: 14,
  //   text: "Python",
  // },
];
export const links = [
  {
    id: 1,
    url: "/",
    text: "Home",
  },
  {
    id: 2,
    url: "/resume",
    text: "Resume",
  },
  {
    id: 3,
    url: "/skills",
    text: "Skills",
  },
  {
    id: 4,
    url: "/projects",
    text: "Projects",
  },
  {
    id: 5,
    url: "/hobbies",
    text: "Hobbies",
  },
];
export const topProjects = [
  {
    id: 1,
    icon: <RiFocus3Fill />,
    text: "FocusForge",
    category: "Web",
    vid: "", //to be added
    desc: "The software helps with studying efficiency. It contains a productivity timer, a motivational quotation board, focus-enhancing music, a drawing pad for creativity, a task list for organization, and an AI chatbot for help. \n\n Secured user data with jwt tokens and hashed passwords, and authentication middleware. To add to the features, reset password and email verification were also implemented. \n\n Developed a local storage solution to securely store user data, alongside a database that enables administrators to add music and quotes for universal access on the website. \n\n Developed a custom audio player, progress bar, and a drawing pad utilizing Canvas API. Additionally, implemented an AI chat bot assistant through Open AI API. \n\n",
    url: "https://www.focusforge.ca",
  },
  {
    id: 2,
    icon: <MdOutlineLocalGroceryStore />,
    text: "EasyGrocery",
    category: "Web",
    vid: "", //to be added
    desc: "Developed an application designed to assist consumers in managing their shopping lists, monitoring grocery expenditures, digitally storing receipts, and enhancing list creation efficiency with AI technologies.\n\n A client-server REST API was built so users can perform CRUD operations using Node JS and React. Used MongoDB and authentication for cross-device data access. The database and authentication were secured via JWT, cookies, email verification, and password hashing.\n\n A rapid ingredients generating tool was created using Open AI API to process recipe input.",
    url: "https://www.easygrocery.org",
  },
  {
    id: 3,
    icon: <FaMosque />,
    text: "Spiritual Development App ",
    category: "Web",
    vid: "", //to be added
    desc: "The software included all the key tools for the Muslim faith. It showed prayer times and countdown for the next prayer. He or she can view or listen to the Quran, locate the nearest mosque, check the prayer times and the countdown for the next prayer.\n\n React was used to build the user interface for fast updates and performance. A custom audio player was also built to play full chapters or single versus separately. Additionally, responsive design was added to the app to optimize viewing across all screen sizes. \n\n Integrated Google Maps API for finding the nearest mosque, Quran API for reading and listening to the Quran, and a Prayers API for monitoring prayer times, into a NodeJS server. The client interacts with the backend using the REST API architecture.\n\n",
    url: "https://www.tojannahfirdous.com",
  },
  {
    id: 4,
    icon: <BiPaint />,
    text: "Art Store Website",
    category: "Web",
    vid: "",
    desc: "This is an online art store where I display all my realistic art that I painted. \n\n I used Figma to design the page keeping in mind the responsiveness of the design, then moved on to implementing the design on VS Code using CSS, HTML, React JS, Styled Components and more. The code was then pushed to Github and deployed using Netlify. \n\n I have learnt how to also create a login page and create private routes as well for this page. I also used Stripe to create a checkout page. Then used Netlify CLI and ntl dev to test it locally. Right now the Stripe payment is still in testing mode but you can use the test card provided on top of the checkout form and make up a cvv and an expiration date. You will see that it works! \n\n",
    url: "https://art-store-fatima.netlify.app/",
  },
  {
    id: 5,
    icon: <FaRobot />,
    text: "Autonomous Robot",
    category: "Embedded",
  },
];

export const projects = [
  {
    id: 1,
    icon: <RiFocus3Fill />,
    text: "FocusForge",
    category: "Web",
    vid: "", //to be added
    desc: "The software helps with studying efficiency. It contains a productivity timer, a motivational quotation board, focus-enhancing music, a drawing pad for creativity, a task list for organization, and an AI chatbot for help. \n\n Secured user data with jwt tokens and hashed passwords, and authentication middleware. To add to the features, reset password and email verification were also implemented. \n\n Developed a local storage solution to securely store user data, alongside a database that enables administrators to add music and quotes for universal access on the website. \n\n Developed a custom audio player, progress bar, and a drawing pad utilizing Canvas API. Additionally, implemented an AI chat bot assistant through Open AI API. \n\n",
    url: "https://www.focusforge.ca",
  },
  {
    id: 2,
    icon: <MdOutlineLocalGroceryStore />,
    text: "EasyGrocery",
    category: "Web",
    vid: "", //to be added
    desc: "Developed an application designed to assist consumers in managing their shopping lists, monitoring grocery expenditures, digitally storing receipts, and enhancing list creation efficiency with AI technologies.\n\n A client-server REST API was built so users can perform CRUD operations using Node JS and React. Used MongoDB and authentication for cross-device data access. The database and authentication were secured via JWT, cookies, email verification, and password hashing.\n\n A rapid ingredients generating tool was created using Open AI API to process recipe input.",
    url: "https://www.easygrocery.org",
  },
  {
    id: 3,
    icon: <FaMosque />,
    text: "Spiritual Development App ",
    category: "Web",
    vid: "", //to be added
    desc: "The software included all the key tools for the Muslim faith. It showed prayer times and countdown for the next prayer. He or she can view or listen to the Quran, locate the nearest mosque, check the prayer times and the countdown for the next prayer.\n\n React was used to build the user interface for fast updates and performance. A custom audio player was also built to play full chapters or single versus separately. Additionally, responsive design was added to the app to optimize viewing across all screen sizes. \n\n Integrated Google Maps API for finding the nearest mosque, Quran API for reading and listening to the Quran, and a Prayers API for monitoring prayer times, into a NodeJS server. The client interacts with the backend using the REST API architecture.\n\n",
    url: "https://www.tojannahfirdous.com",
  },

  {
    id: 4,
    icon: <SiIkea />,
    text: "IKEA | Imitation",
    category: "Web",
    vid: "",
    desc: "This is a responsive IKEA clone page. I built this page for me to practice and to showcase my frontend and backend programming skills. It is not fully functional as it is not meant to check out any real product. \n\n In this project, I used MERN ( Mongo, Express, React, Node), which is a widely used technology stack by many leading companies. For authentication, I used JWT (JSON Web Tokens) and bcryptjs library for hashing passwords in case the database is ever compromised. \n\n Some of what you can do on the website: \n\n - Register and Login \n\n - Quickly Login as a guest \n\n - Add and modify cart items\n\n - Add and modify shopping list items\n\n - Search for products \n\n - Change your postal code \n\n For those interested in checking out the code, visit the following GitHub link: https://github.com/FatimaLDL1997/ikea-store-build\n\n Skills: MERN Stack · JSON Web Token (JWT) · HTML5 · Cascading Style Sheets (CSS) · styled-components · Node.js · MongoDB · React.js\n\n",
    url: "https://art-store-fatima.netlify.app/",
  },
  {
    id: 5,
    icon: <MdFoodBank />,
    text: "Let's Share Our Recipes",
    category: "Web",
    vid: "",
    desc: "",
    url: "https://lets-share-our-recipes.onrender.com",
  },
  {
    id: 6,
    icon: <BiPaint />,
    text: "Art Store Website",
    category: "Web",
    vid: "",
    desc: "This is an online art store where I display all my realistic art that I painted. \n\n I used Figma to design the page keeping in mind the responsiveness of the design, then moved on to implementing the design on VS Code using CSS, HTML, React JS, Styled Components and more. The code was then pushed to Github and deployed using Netlify. \n\n I have learnt how to also create a login page and create private routes as well for this page. I also used Stripe to create a checkout page. Then used Netlify CLI and ntl dev to test it locally. Right now the Stripe payment is still in testing mode but you can use the test card provided on top of the checkout form and make up a cvv and an expiration date. You will see that it works! \n\n",
    url: "https://art-store-fatima.netlify.app/",
  },
  {
    id: 7,
    icon: <TiWeatherPartlySunny />,
    text: "Weather Web Application",
    category: "Web",
    vid: "",
    desc: "This project is inspired by a Youtube tutorial. I have used an API called Open Weather Map API. The app has very detailed documentation on how to use its parameters. Using the API endpoint/URL I fetched the data from the API through Axios. Axios is a promise-based HTTP client which allows to communicate to the backend and to make HTTP requests from the browser. I have also used codes for icons from the API itself to display the corresponding icon on the application frontend. \n\n",
    url: "https://my-first-weather-app-fatima.netlify.app/",
  },

  {
    id: 8,
    icon: <FaRobot />,
    text: "Autonomous Robot",
    category: "Embedded",
    vid: "https://www.youtube.com/embed/b1aJYZsqKdw",
    desc: `In the last year of my Mechatronics Engineering program, I got to build and program an amazing robotics project that combines Arduino and Python programming together. \n\n The robot's goal is to autonomously find & pick 2 small dark green and 2 big light green Legos and place them at different locations based on their sizes/colours. Then return home. \n\n The robot was able to complete its tasks within the time limit given and return exactly where it started out.`,
  },
  {
    id: 9,
    icon: <AiFillCar />,
    text: "Bluetooth RC Car",
    category: "Embedded",
    vid: "https://www.youtube.com/embed/_VZ0PIWQRv4",
    desc: "RC Car Inspired by DIY RC Cars online, I created my own from scratch using Arduino, 2 back gear motors, Adafruit Motor shield and a simplified steering mechanism. \n\n The first prototype of this project was made from cardboard. Later, I got to use a laser cutter and a 3D printer to create a nicer and stronger wheel attachment, chassis, and steering mechanism. \n\n The car can be controlled using any smart phone once the 'car controller' app, which I created using MIT App Inventor 2, is downloaded.",
  },
  {
    id: 10,
    icon: <GiFactory />,
    text: "Factory I/O Simulations",
    category: "Manufacturing",
    vid: "https://www.youtube.com/embed/GX4YVvpWhGs",
    desc: "Factory I/O is a software that provides more than 20 scenes inspired by real world control tasks in factories and warehouses. It also provides the user with flexibility to create their own control tasks. \n\n These control systems in Factory I/O can be controlled using many different drivers including but not limited to all PLC brands and common automation technologies in the market. \n\n For my Factory I/O projects, I used WinSPS-S7, which is a programming and simulation software that can be connected to Factory I/O for simulation, and can allow the use of LAD, STL and FBD programming languages. I also used block coding in the Control I/O driver to program some of other scenes. \n\n\n Feel free to check out the demo video below: \n\n ",
  },
  {
    id: 11,
    icon: <TbDeviceComputerCamera />,
    text: "Python Security Camera",
    category: "Security",
    vid: "https://www.youtube.com/embed/P8fikhLsUjo",
    desc: " I coded a Python Security Camera app which uses scikit-image, a collection of algorithms and a part of the image processing in Python, Scikit-image can be used for computing the mean structural similarity index between current and previous image frames which is how motion can be detected in a video.  \n\n The application gives the user time to leave the space so that the detection doesn’t start right away by setting up a timer. Once the timer is done counting down, comparison between image frames will start and, thus, any motion detection will be sent over text to the user immediately. \n\n Also, if any motion is detected, a video recording of that instance will be stored in the security camera file under ‘output.avi’.  \n\n\n Feel free to check out the demo video below: \n\n ",
  },
  {
    id: 12,
    icon: <FaCube />,
    text: "3D Cadded Models",
    category: "Modelling",
    vid: "https://www.youtube.com/embed/IklHF9jQogU",
    desc: "I have created many 3D models during my studies. Some of the best are the ones shown in the video below: ",
  },
];
export const skills = [
  {
    id: 1,
    url: "/images/html.png",
    category: "Web",
    text: "HTML",
  },
  {
    id: 2,
    url: "/images/nx12.png",
    category: "cadding",
    text: "Seimens NX",
  },
  {
    id: 3,
    url: "/images/factoryIO.png",
    category: "manufacturing",
    text: "Factory IO",
  },
  {
    id: 4,
    url: "/images/arduino.png",
    category: "microcontrollers",
    text: "Arduino",
  },
  {
    id: 5,
    url: "/images/soldering.png",
    category: "hardware",
    text: "Soldering",
  },
  {
    id: 6,
    url: "/images/css.png",
    category: "Web",
    text: "CSS",
  },
  {
    id: 7,
    url: "/images/react.png",
    category: "Web",
    text: "REACT",
  },
  {
    id: 8,
    url: "/images/js.png",
    category: "Web",
    text: "JS",
  },
  {
    id: 9,
    url: "/images/raspberryPI.png",
    category: "microcontrollers",
    text: "Raspberry Pi",
  },
  {
    id: 10,
    url: "/images/sw.png",
    category: "cadding",
    text: "SolidWorks",
  },
  {
    id: 11,
    url: "/images/pcb.png",
    category: "hardware",
    text: "PCB Design",
  },
  {
    id: 12,
    url: "/images/AI.png",
    category: "design",
    text: "Illustrator",
  },
  {
    id: 13,
    url: "/images/python.png",
    category: "software",
    text: "Python",
  },
  {
    id: 14,
    url: "/images/c.png",
    category: "software",
    text: "C",
  },
  {
    id: 15,
    url: "/images/C++.png",
    category: "software",
    text: "C++",
  },
  {
    id: 17,
    url: "/images/java.png",
    category: "software",
    text: "Java",
  },
  {
    id: 18,
    url: "/images/figma.png",
    category: "Web",
    text: "Figma",
  },
  {
    id: 19,
    url: "/images/fusion.png",
    category: "cadding",
    text: "Fusion",
  },
  {
    id: 20,
    url: "/images/gimp.png",
    category: "design",
    text: "Gimp",
  },
  {
    id: 21,
    url: "/images/inkscape.png",
    category: "design",
    text: "Inkscape",
  },
  {
    id: 22,
    url: "/images/matlab.png",
    category: "software",
    text: "Matlab",
  },
  {
    id: 23,
    url: "/images/mhj.svg",
    category: "software",
    text: "MHJ",
  },
  {
    id: 24,
    url: "/images/mySQL.png",
    category: "Web",
    text: "MySQL",
  },
  {
    id: 25,
    url: "/images/office.png",
    category: "software",
    text: "Office",
  },
  {
    id: 26,
    url: "/images/oop.png",
    category: "software",
    text: "OOP",
  },
  {
    id: 27,
    url: "/images/ps.png",
    category: "design",
    text: "Photoshop",
  },
  {
    id: 28,
    url: "/images/ros.png",
    category: "software",
    text: "ROS",
  },
  {
    id: 29,
    url: "/images/sketchup.png",
    category: "cadding",
    text: "Sketch Up",
  },
  {
    id: 30,
    url: "/images/autocad.png",
    category: "cadding",
    text: "Auto CAD",
  },
  {
    id: 31,
    url: "/images/tinkercad.png",
    category: "cadding",
    text: "Tinker CAD",
  },
  {
    id: 32,
    url: "/images/nodejs.png",
    category: "Web",
    text: "Node.js",
  },
  {
    id: 32,
    url: "/images/mongodb.png",
    category: "Web",
    text: "MongoDB",
  },
  {
    id: 33,
    url: "/images/express.png",
    category: "Web",
    text: "Express JS",
  },
  {
    id: 34,
    url: "/images/tailwind.png",
    category: "Web",
    text: "Tailwind",
  },
  {
    id: 35,
    url: "/images/daisyui.png",
    category: "Web",
    text: "DaisyUI",
  },
];

export const hobbies = [
  {
    id: 8,
    img: "/images/art/forest.jpg",
    text: " Forest Vibes - Acrylics",
    price: "2.0",
    category: "nature",
  },
  {
    id: 3,
    img: "/images/art/beach.jpg",
    text: "Tropical Beach - Acrylics",
    price: "2.0",
    category: "nature",
  },
  {
    id: 2,
    img: "/images/art/hammock.jpg",
    text: "Hammock on the Sea - Acrylics",
    price: "2.0",
    category: "nature",
  },
  {
    id: 4,
    img: "/images/art/river.png",
    text: "River - digital",
    price: "2.0",
    category: "nature",
  },
  {
    id: 5,
    img: "/images/art/actor2.PNG",
    text: "Turkish Actress - Prisma",
    price: "2.0",
    category: "portraits",
  },
  {
    id: 6,
    img: "/images/art/balloon_LI.jpg",
    text: "Air Baloon - Digital",
    price: "2.0",
    category: "objects",
  },
  {
    id: 7,
    img: "/images/art/bearzoom.jpg",
    text: "Bear (zoomed) - oil pastal",
    price: "2.0",
    category: "animals",
  },
  {
    id: 1,
    img: "/images/art/cat.PNG",
    text: "Cat - Prisma",
    price: "2.0",
    category: "animals",
  },
  {
    id: 9,
    img: "./images/art/dog.PNG",
    text: "Dog - Prisma",
    price: "2.0",
    category: "animals",
  },
  {
    id: 10,
    img: "/images/art/elephant.jpg",
    text: "Elephant - Oil Pastal",
    price: "2.0",
    category: "animals",
  },
  {
    id: 12,
    img: "/images/art/horses.PNG",
    text: "Love Horses - Acrylics",
    price: "2.0",
    category: "animals",
  },
  {
    id: 13,
    img: "/images/art/parrot2.PNG",
    text: "Parrots - Prisma",
    price: "2.0",
    category: "animals",
  },
  {
    id: 14,
    img: "/images/art/panda.PNG",
    text: "Panda - Prisma",
    price: "2.0",
    category: "animals",
  },
  {
    id: 15,
    img: "/images/art/boy.PNG",
    text: "Young Actor - Graphite",
    price: "2.0",
    category: "portraits",
  },
  {
    id: 16,
    img: "/images/art/window.PNG",
    text: "Window - Acrylics",
    price: "2.0",
    category: "objects",
  },

  {
    id: 17,
    img: "/images/art/dreams.PNG",
    text: " Dreams - Oil Pastal",
    price: "5.0",
    category: "qoutes",
  },
  {
    id: 18,
    img: "/images/art/lillies.JPG",
    text: " Lillies- Oil Pastal",
    price: "4.0",
    category: "nature",
  },
  {
    id: 19,
    img: "/images/art/mermaid.jpg",
    text: "Mermaid - Oil Pastal",
    price: "3.0",
    category: "qoutes",
  },
];

export const footerLinks = [
  {
    id: 1,
    text: "Email",
    icon: <AiOutlineMail />,
    url: "mailto:fatimalabade@gmail.com",
  },
  {
    id: 2,
    text: "LinkedIn",
    icon: <AiOutlineLinkedin />,
    url: "https://www.linkedin.com/in/fatima-labade/",
  },
  {
    id: 3,
    text: "Github",
    icon: <AiFillGithub />,
    url: "https://github.com/FatimaLDL1997?tab=repositories",
  },
];
